import * as Scrivito from "scrivito";
import defaultSocialHeaderButtonAttributes from "../_defaultSocialHeaderButtonAttributes";

const TwitterSocialHeaderButton = Scrivito.provideObjClass(
  "TwitterSocialHeaderButton",
  defaultSocialHeaderButtonAttributes,
);

export default TwitterSocialHeaderButton;
